import { useState, forwardRef, useEffect } from "react";
import PropTypes from 'prop-types';
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import { useAuth } from "../../Auth/AuthContext";
import SweetAlert2 from 'react-sweetalert2';
import DataTable from 'react-data-table-component';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import { Tooltip } from 'react-tooltip';
import Select from 'react-select';
import MenuCaracterizacion from "../Caracterizacion/Componentes/MenuCaracterizacion";
import { FaCalendar, FaEraser } from "react-icons/fa";

registerLocale('es', es);
setDefaultLocale('es');

const Integrante = ({ register, index, defaultValues, ordenOcupacionActual, perfilesOcupacional, estudiosactual, mesesGestancia, tiposDiscapacidad }) => {
    return (
    <div style={{borderBlock:'2px solid gray'}}>
        <h5><b>Nombre:</b> {defaultValues.nombre}</h5>
        <div className="row" >
            <div className="col-md-6">
                <p><b>Identificacion:</b> {defaultValues.per_idpersona}, <b>Fecha nacimiento:</b> {defaultValues.par_parentesco}</p>
            </div>
            <div className="col-md-6">
                <p><b>parentesco:</b> {defaultValues.par_parentesco}, <b>Etnia:</b> {defaultValues.par_etnia}, <b>Edad:</b> {defaultValues.par_edad}</p>
            </div>
        </div>
        <input hidden id={`idPersona-${index}`} {...register(`integrantes.${index}.idPersona`, { required: true })} defaultValue={defaultValues.per_idpersona}/>
        <div className="row">
            <div className="col-md-3">
                <div className="form-group">
                    <label htmlFor={`ocupacionActual-${index}`}>Ocupaci&oacute;n Actual (despu&eacute;s del R&R):</label>
                    <select id={`ocupacionActual-${index}`} {...register(`integrantes.${index}.ocupacionActual`, { required: true })} className="form-control">
                        <option value="">Seleccionar</option>
                        {ordenOcupacionActual.map((option) => (
                            <option key={option.id} value={option.id}>
                            {option.id} {option.ocuOcupacion}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label htmlFor={`perfilOcupacional-${index}`}>Perfil Ocupacional:</label>
                    <select id={`perfilOcupacional-${index}`} {...register(`integrantes.${index}.perfilOcupacional`, { required: true })} className="form-control">
                        <option value="">Seleccionar</option>
                        {perfilesOcupacional.map((option) => (
                            <option key={option.id} value={option.id}>
                            {option.id} {option.perfil}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label htmlFor={`estudioActual-${index}`}>Estudia Actualmente y grado de escolaridad (despu&eacute;s del R&R):</label>
                    <select id={`estudioActual-${index}`} {...register(`integrantes.${index}.estudioActual`, { required: true })} className="form-control">
                        <option value="">Seleccionar</option>
                        {estudiosactual.map((option) => (
                            <option key={option.id} value={option.id}>
                            {option.id} {option.perfil}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="col-md-3 alfinal" >
                <div className="form-group alfinal">
                    Gestante : <input type="checkbox" id={`gestante-${index}`} {...register(`integrantes.${index}.gestante`)} />
                </div>
                <div className="form-group">
                    <label htmlFor={`mesesGestante-${index}`}>Meses:</label>
                    <select id={`mesesGestante-${index}`} {...register(`integrantes.${index}.mesesGestante`, { required: true })} className="form-control">
                        <option value="">Seleccionar</option>
                        {mesesGestancia.map((option) => (
                            <option key={option.id} value={option.id}>
                            {option.id} {option.perfil}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="form-group alfinal">
                    Lactante : <input type="checkbox" id={`lactante-${index}`} {...register(`integrantes.${index}.lactante`)} />
                </div>
            </div>
            <div className="col-md-3">
                <div className="form-group">
                    <label htmlFor={`discapacidad-${index}`}>Discapacidad SI o NO y cu&aacute;l:</label>
                    <select id={`discapacidad-${index}`} {...register(`integrantes.${index}.discapacidad`, { required: true })} className="form-control">
                        <option value="">Seleccionar</option>
                        {tiposDiscapacidad.map((option) => (
                            <option key={option.id} value={option.id}>
                            {option.id} {option.perfil}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            
            <hr />
        </div>
    </div>
    )
  }
Integrante.propTypes = {
    register: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    defaultValues: PropTypes.object.isRequired,
    ordenOcupacionActual: PropTypes.array.isRequired,
    perfilesOcupacional: PropTypes.array.isRequired,
    estudiosactual: PropTypes.array.isRequired,
    mesesGestancia: PropTypes.array.isRequired,
    tiposDiscapacidad: PropTypes.array.isRequired,
};

const ActionCell = ({ row, onSelect }) => (
        <div>
            <button type="button" onClick={() => onSelect(row)} 
                    style={{backgroundColor: 'blue'}} 
                    data-tooltip-id='tooltiparriba'
                    data-tooltip-content="Administrar seguimiento retornos">
                        <FaEraser size={20} color="white" />
            </button>
        </div>
      );
const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div className="custom-input">
        <input value={value} readOnly className='widthCalendar' onClick={onClick} ref={ref}/>
        <FaCalendar size={20} color="black" />
    </div>
));
export default function SeguimientoRetorno(){
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [retornoId, setRetornoId] = useState(0);
    const [swalProps, setSwalProps] = useState({});
    const [integrantes, setIntegrantes] = useState([]);
    const [retornosactivo, setRetornosactivo] = useState([]);
    const [salud, setSalud] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [rangosIngresosMensual, setRangosIngresosMensual] = useState([]);
    const [ordenOcupacionActual, setOrdenOcupacionActual] = useState([]);
    const [perfilesOcupacional, setPerfilesOcupacional] = useState([]);
    const [estudiosactual, setEstudiosactual] = useState([]);
    const [mesesGestancia, setMesesGestancia] = useState([]);
    const [tiposDiscapacidad, setTiposDiscapacidad] = useState([]);
    const [estadosBien, setRetornoEstadosBien] = useState([]);
    const [requiereFortalecerActividadEconomica, setrequiereFortalecerActividadEconomica] = useState([]);
    const [requiereFortalecerActividadEconomicaSeleccionados, setrequiereFortalecerActividadEconomicaSeleccionados] = useState([]);
    const { control, handleSubmit, register, setValue, watch, getValues, reset, formState: { errors }} = useForm();
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        cab_telefono1: '',
        cab_telefono2: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const [CabezaFamiliaRetorno, setCabezaFamiliaRetorno] = useState({
        Departamento: '',
        Municipio: '',
        Entorno: '',
        Corregimiento: '',
        Vereda: '',
        Nombrefinca: '',
        Referencias: ''
      });
      
      const columnsretornoactivo = [
        {
            name: 'Acciones',
            cell: row => <ActionCell row={row} onSelect={SeleccionarRetorno} />,
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Fecha entrevista', selector: row => row.ret_fechaentrevista.split('T')[0], sortable: true, width: '15%'},
        { name: 'Fecha visita', selector: row => row.ret_fechavisitadomiciliaria.split('T')[0], sortable: true, width: '15%'},
        { name: 'Municipio', selector: row => row.mun_municipio, sortable: true, width: '15%' },
        { name: 'Departamento', selector: row => row.dep_departamento, sortable: true, width: '10%' }
    ];
    function SeleccionarRetorno (row){
        setRetornoId(row.id);
    };
    useEffect(() => {
        const fetchData = async () => {
            const url = '/retorno/seguimiento/crearforminicioseguimientoretornos';
            const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setIntegrantes(result.integrantesdto);
                setRetornosactivo(result.retornosactivos);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, [idCabezaFamilia, rol, token]);
    const onSubmit = async (data) => {
        const values = getValues();
        setCargando(true);
        let url;
        url = '/retorno/registraroatencionseguimiento';
        try {
            const response = await apiService.post(url, values, token);
            if(response.status === 200){
                Mensaje('Registrar atencion', JSON.stringify(response.data));
                reset({
                    atencionesfields: []
                  });
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            ResetForm();
        }
        
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        const fechahoy = new Date()
        setValue('fecha', fechahoy);
        setValue('idpersona', '');
        setValue('entidad', 1);
        setValue('tipoahuid', '');
        setValue('tipoentregaid', '');
        setValue('naturalezaid', '');
        setValue('cantidad', 0);
        setValue('tiponaturalezaid', '2');
        setValue('idayuda', '');
        setValue('valorunitario', 0);
        setValue('observaciones', '');
    }
    
    const ActualizarMunicipiosSalud = async (event) => {
        const url = '/retorno/consultarmunicipios';
        const obj = {DepartamentoId: event.target.value }
        try {
            setCargando(true);
            const responsemunicipios = await apiService.post(url, obj, token);
            const resultmunicipios = await responsemunicipios.data;
            setMunicipios(resultmunicipios);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
      };
    const ActualizarRequiereFortalecerAutEconomica = dato => {
        setrequiereFortalecerActividadEconomicaSeleccionados(dato);
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Seguimiento a retornos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/retornos/retorno/${idCabezaFamilia}`} >Retornos</NavLink></li>}
                        <li className="breadcrumb-item active"> Seguimiento a retornos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia}/>
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-info">
                        <div className="card-header">
                            <h3 className="card-title">Seguimiento</h3>
                        </div>
                        {/* /.card-header */}
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title m-0">Datos del declarante</h5>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                <div className="col-md-12">
                                    Nombre: <b>{CabezaFamiliaDatos.nombre}</b>
                                </div>
                                </div>
                                <div className="row">
                                <div className="col-md-4">
                                    Identificacion: <b>{CabezaFamiliaDatos.cab_idcabezafamilia}</b>
                                </div>
                                </div>
                                <div className="row">
                                <div className="col-md-4">
                                    Direccion: <b>{CabezaFamiliaDatos.cab_direccion}</b>
                                </div>
                                <div className="col-md-3">
                                    Telefonos: <b>{CabezaFamiliaDatos.cab_telefono1} - {CabezaFamiliaDatos.cab_telefono2}</b> 
                                </div>
                                <div className="col-md-3">
                                    Celular: <b>{CabezaFamiliaDatos.cab_celular}</b>
                                </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        Departamento: <b>{CabezaFamiliaRetorno.Departamento}</b>
                                    </div>
                                    <div className="col-md-3">
                                        Municipio: <b>{CabezaFamiliaRetorno.Municipio}</b>
                                    </div>
                                    <div className="col-md-3">
                                        Entorno: <b>{CabezaFamiliaRetorno.Entorno}</b>
                                    </div>
                                    
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        Corregimiento: <b>{CabezaFamiliaRetorno.Corregimiento}</b>
                                    </div>
                                    <div className="col-md-3">
                                        Vereda: <b>{CabezaFamiliaRetorno.Vereda}</b>
                                    </div>
                                    <div className="col-md-3">
                                        Nombre de la finca: <b>{CabezaFamiliaRetorno.Nombrefinca}</b>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        Referencias del lugar de llegada: <b>{CabezaFamiliaRetorno.Referencias}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            {retornosactivo.length > 0 && <div className="col-md-12">
                                <div className="card-body table-responsive p-0">
                                    <DataTable
                                        title="Retornos de esta familia"
                                        columns={columnsretornoactivo}
                                        data={retornosactivo}    
                                        progressPending={Cargando}
                                        pagination
                                        noDataComponent="No hay datos para mostrar"
                                    /> 
                                </div>
                            </div>}
                        </div>
                        
                        {/* form start */}
                        {retornoId !== 0 && <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <div className="card-body">
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                <div className="row">
                                    <div className='col-md-3'>
                                        <div className="form-group">
                                            <label htmlFor="fechaVisita">Fecha realizaci&oacute;n visita:</label>
                                            <Controller
                                                
                                                control={control}
                                                name="fechaVisita"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    id="fechaVisita"
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    />
                                                )}
                                            />
                                            {errors.fechaEntrevista && <p style={{color: 'red'}}>Digite fecha entrevista</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h3>1. VALORACI&oacute;N SITUACI&oacute;N INICIAL ENCONTRADA</h3>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('valoracionSituacionInicial', { required: true })}
                                                placeholder="Valoración inicial"
                                            />
                                            {errors.valoracionSituacionInicial && <p style={{color: 'red'}}>Favor digite la valoracion</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <strong>El acompañamiento realizado correspondi&oacute; a:</strong>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            REUBICACI&oacute;N
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>2. CONFORMACI&oacute;N N&uacute;CLEO FAMILIAR</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                    <div className="card-body">
                                        <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                        {integrantes.map((integrante, index) => (
                                        <Integrante 
                                                key={index} 
                                                register={register} 
                                                index={index} 
                                                defaultValues={integrante}
                                                ordenOcupacionActual={ordenOcupacionActual}
                                                perfilesOcupacional={perfilesOcupacional}
                                                estudiosactual={estudiosactual}
                                                mesesGestancia={mesesGestancia}
                                                tiposDiscapacidad={tiposDiscapacidad}/>
                                        ))}
                                    </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>3. HABITABILIDAD</h3>
                                    </div>
                                </div>    
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            La vivienda en el lugar del retorno o la reubicaci&oacute;n es de alg&uacute;n integtrante de la familia incluida:
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            SI
                                        </div>
                                    </div>
                                </div>      
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            A. Tiene documentaci&oacute;n de esa vivienda o tierras
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            SI
                                        </div>
                                    </div>
                                </div>  
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            Protegi&oacute; el bien abandonado
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            SI
                                        </div>
                                    </div>
                                </div>      
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            ¿Qu&eacute; tipo de bien es?
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            SI
                                        </div>
                                    </div>
                                </div>    
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            Tiene Resolucion de protecci&oacute;n
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            SI
                                        </div>
                                    </div>
                                </div>    
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>CONDICIONES ACTUALES DE LA VIVIENDA</h3>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-1">
                                        TECHO
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoTecho">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="estadoTecho" {...register('estadoTecho', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoTecho && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-1">
                                    PISOS
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoPisos">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select {...register('estadoPisos', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoPisos && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-1">
                                    BAÑOS
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoBanos">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="estadoBanos" {...register('estadoBanos', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoBanos && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-1">
                                    PAREDES
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoParedes">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id='estadoParedes' {...register('estadoParedes', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoParedes && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-1">
                                    COCINA
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoCocina">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="estadoCocina" {...register('estadoCocina', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoCocina && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                    LA SOLUCI&oacute;N HABITACIONAL CUENTA CON SERVICIO DE ALCANTARILLADO	
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoTecho">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="servicioAlcantarillado" {...register('servicioAlcantarillado', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioAlcantarillado && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                    LA SOLUCI&oacute;N HABITACIONAL CUENTA CON POZO S&eacute;PTICO	
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoTecho">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="servicioPozoSeptico" {...register('servicioPozoSeptico', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioPozoSeptico && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                    LA SOLUCI&oacute;N HABITACIONAL CUENTA CON SERVICIO DE ACUEDUCTO	
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoTecho">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="servicioAcueducto" {...register('servicioAcueducto', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioAcueducto && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                    LA SOLUCI&oacute;N HABITACIONAL CUENTA CON OTRA FUENTE DE ABASTECIMIENTO DE AGUA POTABLE	
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="servicioAlcantarillado">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="otraFuenteAgua" {...register('otraFuenteAgua', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.otraFuenteAgua && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                    LA SOLUCI&oacute;N HABITACIONAL CUENTA CON SERVICIO DE ENERG&iacute;A	
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            Informaci&oacute;n caracterizacion: Malo
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoTecho">INFORMACI&oacute;N SEGUIMIENTO (VERIFICACI&oacute;N OCULAR):</label>
                                            <select id="servicioEnergia" {...register('servicioEnergia', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioEnergia && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>Tiene deudas de:	</h5>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaServicios">a. servicios p&uacute;blicos:</label>
                                            <select id="deudaServicios" {...register('deudaServicios', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.deudaServicios && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaServiciosCuanto">Cuanto:</label>
                                            <input id="deudaServiciosCuanto" {...register('deudaServiciosCuanto')}  className="form-control" placeholder="0"/>
                                            {errors.deudaServiciosCuanto && <p style={{color: 'red'}}>Digite parentesco</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaPredial">b. impuesto predial:</label>
                                            <select id="deudaPredial" {...register('deudaPredial', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.deudaPredial && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaPredialCuanto">Cuanto:</label>
                                            <input id="deudaPredialCuanto" {...register('deudaPredialCuanto')}  className="form-control" placeholder="0"/>
                                            {errors.deudaPredialCuanto && <p style={{color: 'red'}}>Digite parentesco</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaValoricacion">c. valorizaci&oacute;n:</label>
                                            <select id="deudaValoricacion" {...register('deudaValoricacion', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.deudaValoricacion && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaValoricacionCuanto">Cuanto:</label>
                                            <input id="deudaValoricacionCuanto" {...register('deudaValoricacionCuanto')}  className="form-control" placeholder="0"/>
                                            {errors.deudaValoricacionCuanto && <p style={{color: 'red'}}>Digite parentesco</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaBanco">d. pr&eacute;stamo banco y/o cooperativas:</label>
                                            <select id="deudaBanco" {...register('deudaBanco', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.deudaBanco && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="deudaBancoCuanto">Cuanto:</label>
                                            <input id="deudaBancoCuanto" {...register('deudaBancoCuanto')}  className="form-control" placeholder="0"/>
                                            {errors.deudaBancoCuanto && <p style={{color: 'red'}}>Digite parentesco</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>4. ACCESO A PROGRAMAS Y SERVICIOS EN EL MUNICIPIO DE ACTUAL RESIDENCIA</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="familiasEnAccion">A. Familias en Acci&oacute;n:</label>
                                            <select id="familiasEnAccion" {...register('familiasEnAccion', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.familiasEnAccion && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="familiasEnAccionMotivo">Motivos:</label>
                                            <input id="familiasEnAccionMotivo" {...register('familiasEnAccionMotivo')}  className="form-control" placeholder="0"/>
                                            {errors.familiasEnAccionMotivo && <p style={{color: 'red'}}>Digite motivo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="redUnidos">B. Red Unidos</label>
                                            <select id="redUnidos" {...register('redUnidos', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.redUnidos && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="redUnidosMotivo">Motivos:</label>
                                            <input id="redUnidosMotivo" {...register('redUnidosMotivo')}  className="form-control" placeholder="0"/>
                                            {errors.redUnidosMotivo && <p style={{color: 'red'}}>Digite motivo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                     C. Ayuda Humanitaria entregada por Acci&oacute;n Social:
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="fechaAHE">Fecha de la &uacute;ltima vez que recibi&oacute; esta asistencia</label>
                                            <Controller
                                                id="fechaAHE"
                                                control={control}
                                                name="fechaAHE"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fechaAHE && <p style={{color: 'red'}}>Digite fecha AHE</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="valorAHE">Valor del Giro recibido:</label>
                                            <input id="valorAHE" {...register('valorAHE')}  className="form-control" placeholder="0"/>
                                            {errors.valorAHE && <p style={{color: 'red'}}>Digite valor</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="estadoSalud">D. Afiliaci&oacute;n Salud</label>
                                            <select id="estadoSalud" {...register('estadoSalud', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {salud.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.salud}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoSalud && <p style={{color: 'red'}}>Seleccione salud</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="departamentoSalud">Departamento afiliaci&oacute;n</label>
                                            <select id="departamentoSalud" {...register('departamentoSalud', { required: true })} onChange={ActualizarMunicipiosSalud} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {departamentos.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.depDepartamento}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.departamentoSalud && <p style={{color: 'red'}}>Seleccione departamento</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="municipioSalud">Municipio de afiliaci&oacute;n</label>
                                            <select id="municipioSalud" {...register('municipioSalud', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {municipios.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.munMunicipio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.municipioSalud && <p style={{color: 'red'}}>Seleccione municipio</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="educacionNNA">E. Educaci&oacute;n: Los niños se encuentran actualmente estudiando</label>
                                            <select id="educacionNNA" {...register('educacionNNA', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.educacionNNA && <p style={{color: 'red'}}>Seleccione educacion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="educacionNNAPorqueNo">Si la respuesta es NO, marque la situaci&oacute;n por la que no lo est&aacute;:</label>
                                            <input id="educacionNNAPorqueNo" {...register('educacionNNAPorqueNo')}  className="form-control" placeholder=""/>
                                            {errors.educacionNNAPorqueNo && <p style={{color: 'red'}}>Digite motivo no</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        F. Vinculaci&oacute;n a programas del ICBF
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="hogarComunitario">Hogar Comunitario</label>
                                            <select id="hogarComunitario" {...register('hogarComunitario', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.hogarComunitario && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="restauranteEscolar">Restaurante Escolar</label>
                                            <select id="restauranteEscolar" {...register('restauranteEscolar', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.restauranteEscolar && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="clubJuvenil">Clubes Juveniles</label>
                                            <select id="clubJuvenil" {...register('clubJuvenil', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.clubJuvenil && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="madresGestantes">Madres gestantes/lactantes</label>
                                            <select id="madresGestantes" {...register('madresGestantes', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.madresGestantes && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="progCeroSiempre">Programa de Cero a Siempre</label>
                                            <select id="progCeroSiempre" {...register('progCeroSiempre', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.progCeroSiempre && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="derechosPrimero">Programa mis Derechos Primero (Auto 251)</label>
                                            <select id="derechosPrimero" {...register('derechosPrimero', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.derechosPrimero && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="atencionMujeresAnt">Programa Atenci&oacute;n mujeres (Auto 092)</label>
                                            <select id="atencionMujeres" {...register('atencionMujeres', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.atencionMujeres && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                    G. Vinculaci&oacute;n a Programas de la Secretar&iacute;a Seccional de Salud de Antioquia (aplica para familias que se encuentren dentro de los municipios del Departamento de Antioquia)
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="atencionPsicosocial">Atenci&oacute;n Psicosocial</label>
                                            <select id="atencionPsicosocial" {...register('atencionPsicosocial', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.atencionPsicosocial && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="adultoMayor">Programa Adulto Mayor</label>
                                            <select id="adultoMayor" {...register('adultoMayor', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.adultoMayor && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="derechosPrimeroAnt">Programa mis Derechos Primero (Auto 251)</label>
                                            <select id="derechosPrimeroAnt" {...register('derechosPrimeroAnt', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.derechosPrimeroAnt && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="atencionMujeresAnt">Programa Atenci&oacute;n mujeres (Auto 092)</label>
                                            <select id="atencionMujeresAnt" {...register('atencionMujeresAnt', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.atencionMujeresAnt && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                    H. Vinculaci&oacute;n a Programas de la Tercera Edad
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="adultoMayorJLL">Programa de alimentaci&oacute;n al adulto mayor Juan Luis Londoño</label>
                                            <select id="adultoMayorJLL" {...register('adultoMayorJLL', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.adultoMayorJLL && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="adultoMayorRestaurante">Restaurante</label>
                                            <select id="adultoMayorRestaurante" {...register('adultoMayorRestaurante', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.adultoMayorRestaurante && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="adultoMayorSubsidio">Subsidio econ&oacute;mico</label>
                                            <select id="adultoMayorSubsidio" {...register('adultoMayorSubsidio', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.adultoMayorSubsidio && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="adultoMayorClubVida">Clubes de vida</label>
                                            <select id="adultoMayorClubVida" {...register('adultoMayorClubVida', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.adultoMayorClubVida && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                    I. Vinculaci&oacute;n o acceso a la oferta del Ministerio de Agricultura
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="subsidioVIS">Subsidios de vivienda de inter&eacute;s social rural - VIS rural demanda nacional</label>
                                            <select id="subsidioVIS" {...register('subsidioVIS', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.subsidioVIS && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="creditoAgropecuario">L&iacute;neas de cr&eacute;dito agropecuario</label>
                                            <select id="creditoAgropecuario" {...register('creditoAgropecuario', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.creditoAgropecuario && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="subsidioTierras">Subsidio de tierras</label>
                                            <select id="subsidioTierras" {...register('subsidioTierras', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.subsidioTierras && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="subsidioEmpresaAgropecuaria">Subsidio integral para conformaci&oacute;n de empresas b&aacute;sicas agropecuarias</label>
                                            <select id="subsidioEmpresaAgropecuaria" {...register('subsidioEmpresaAgropecuaria', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.subsidioEmpresaAgropecuaria && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                    J. Vinculaci&oacute;n Programa J&oacute;venes
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="jovenesSena">Programa J&oacute;venes Rurales Emprendedores (SENA)</label>
                                            <select id="jovenesSena" {...register('jovenesSena', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.jovenesSena && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="jovenesAccion">Capacitaciones J&oacute;venes en Acci&oacute;n</label>
                                            <select id="jovenesAccion" {...register('jovenesAccion', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                                <option value="Requiere">Requiere acceso</option>
                                            </select>
                                            {errors.jovenesAccion && <p style={{color: 'red'}}>Seleccione</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>5. SOCIO ECON&oacute;MICO</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                    Inter&eacute;s y vocaciones 
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                    2. Componente seguridad alimentaria
                                    </div>
                                </div>
                                
                                <div className="row">
                                    <div className="col-md-2">
                                    Explotaci&oacute;n agr&iacute;cola
                                    </div>
                                    <div className="col-md-6">
                                        <ul>
                                            <li>- Cultivos transitorios</li>
                                            <li>- Cultivos permanentes o frutales</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                    Especies que le gustar&iacute;a trabajar en su predio
                                    </div>
                                    <div className="col-md-6">
                                        <ul>
                                            <li>- Peces</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="areaHuerta">&aacute;rea que dispone para la huerta casera</label>
                                            <input id="areaHuerta" {...register('areaHuerta', { required: true })}  className="form-control" placeholder=""/>
                                            {errors.areaHuerta && <p style={{color: 'red'}}>Digite area</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="actividadEconomica">Actividad econ&oacute;mica que fue acompañada</label>
                                            <input id="actividadEconomica" {...register('actividadEconomica', { required: true })}  className="form-control" placeholder=""/>
                                            {errors.actividadEconomica && <p style={{color: 'red'}}>Digite area</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="impactoProductivo">Gener&oacute; impacto el Plan Productivo Diferencial en la econom&iacute;a familiar</label>
                                            <select id="impactoProductivo" {...register('impactoProductivo', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.impactoProductivo && <p style={{color: 'red'}}>Digite area</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="rangoIngresosMensuales">Rango de ingresos mensuales logrado por la familia despu&eacute;s del proceso de retorno o reubicaci&oacute;n</label>
                                            <select id="rangoIngresosMensuales" {...register('rangoIngresosMensuales', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {rangosIngresosMensual.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.rango}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.rangoIngresosMensuales && <p style={{color: 'red'}}>Digite area</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                    si la respuesta es NO marque
                                    </div>
                                    <div className="col-md-6">
                                        <ul>
                                            <li><input type="checkbox" />_Baja inversi&oacute;n en Plan Productivo Diferencial</li>
                                            <li><input type="checkbox" />_Factores clim&aacute;ticos</li>
                                            <li><input type="checkbox" />_Ausencia de conocimiento del mercado</li>
                                            <li><input type="checkbox" />_Dif&iacute;cil recuperaci&oacute;n de cartera</li>
                                            <li><input type="checkbox" />_Requiere capacitaci&oacute;n para cualificaci&oacute;n</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones y/o comentarios</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="Observaciones"
                                            />
                                            {errors.observaciones && <p style={{color: 'red'}}>Favor digite observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="fortalecerActividadEconomica">Qu&eacute; requerir&iacute;a para fortalecer esta actividad econ&oacute;mica</label>
                                            <Select
                                                id="fortalecerActividadEconomica"
                                                value={requiereFortalecerActividadEconomicaSeleccionados}
                                                isMulti
                                                name="tipoExplotacion"
                                                options={requiereFortalecerActividadEconomica}
                                                onChange={ActualizarRequiereFortalecerAutEconomica}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                            />
                                            {errors.tipoExplotacion && <p style={{color: 'red'}}>Seleccione campos</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>6. FAMILIAR</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="obsDinamicaFamiliar">C&oacute;mo se encuentra la din&aacute;mica familiar (relaciones de pareja, relaciones con los hijos/as, pautas de crianza)</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('obsDinamicaFamiliar', { required: true })}
                                                placeholder="Dinamica"
                                            />
                                            {errors.obsDinamicaFamiliar && <p style={{color: 'red'}}>Favor digite observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="avancesFamilia">En qu&eacute; ha avanzado la familia desde el momento del retorno o reubicaci&oacute;n</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('avancesFamilia', { required: true })}
                                                placeholder="Avances"
                                            />
                                            {errors.avancesFamilia && <p style={{color: 'red'}}>Favor digite observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="metasFamilia">Meta(s) familar(es) planteadas a corto, mediano y largo plazo</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('metasFamilia', { required: true })}
                                                placeholder="Metas"
                                            />
                                            {errors.metasFamilia && <p style={{color: 'red'}}>Favor digite Metas</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="percepcioNNA">Percepci&oacute;n de cada uno de los niños, niñas y/o adolescentes desde el momento de retorno o reubicaci&oacute;n</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('percepcioNNA', { required: true })}
                                                placeholder="Percepcion"
                                            />
                                            {errors.percepcioNNA && <p style={{color: 'red'}}>Favor digite percepcion</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="ObservacionesFinales">Observaciones finales</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('ObservacionesFinales', { required: true })}
                                                placeholder="Observaciones finales"
                                            />
                                            {errors.ObservacionesFinales && <p style={{color: 'red'}}>Favor digite Observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                                <button type="submit" className="btn btn-info">Guardar</button>
                            </div>
                            {/* /.card-footer */}
                        </form>}
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}